import ExtLink from './ExtLink';
import { HeadingFour } from './Text';
import Link from './Link';
import Spotlight from './SpotlightTile';

function SpotlightTiles({ spotlights, status }) {
    if (status === 'idle') return null;
    if (status === 'loading')
        return (
            <Spotlight.TileGrid>
                <Spotlight.Tile isLoading={true} />
                <Spotlight.Tile isLoading={true} />
            </Spotlight.TileGrid>
        );
    if (status === 'error')
        return <div css={HeadingFour}>Failed to load spotlights</div>;
    if (spotlights.length < 1)
        return <div css={HeadingFour}>Could not find any spotlights</div>;

    return (
        <Spotlight.TileGrid>
            {spotlights.map(
                ({
                    id,
                    title,
                    images,
                    link,
                    externalLink,
                    description,
                    updatedStr,
                }) => {
                    const linkProps = {};

                    if (externalLink) {
                        linkProps.href = externalLink;
                        linkProps.target = '_blank';
                        linkProps.rel = 'noopener noreferrer';
                    } else {
                        linkProps.to = link;
                    }

                    return (
                        <Spotlight.Tile
                            key={id}
                            image={images}
                            heading={description}
                            subheading={updatedStr}
                            classification={title}
                            mixpanelContext="SPOTLIGHT_TILE"
                            as={externalLink ? ExtLink : Link}
                            {...linkProps}
                        />
                    );
                },
            )}
        </Spotlight.TileGrid>
    );
}

export default SpotlightTiles;
